import React from "react";
import { useTranslation } from "react-i18next";
import AndroidPlane from "../../assets/images/download_android.png";
import IosPlane from "../../assets/images/download_app_store.png";
import "./style.scss";
import PropTypes from "prop-types";
export default function MobileAppDownloadBlock({ isHideTitle }) {
  MobileAppDownloadBlock.propTypes = {
    isHideTitle: PropTypes.bool,
  };
  const { t } = useTranslation();
  return (
    <div className="mobile-container-download">
      {!isHideTitle && (
        <div className="mobile-container-download__title">
          {t("download_app_desc")}
        </div>
      )}
      <div className="mobile-container-download__imgs">
        <a href="https://apps.apple.com/us/app/in-touch-app/id6472431857">
          <img src={IosPlane} alt="ios plane" />
        </a>
        <a href="/application/android/">
          <img src={AndroidPlane} alt="android plane" />
        </a>
      </div>
    </div>
  );
}
